import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import LocationMarkerIcon from '@heroicons/react/outline/LocationMarkerIcon';
import { Link } from '@tribeplatform/react-ui-kit/Link';
export const LocationView = ({ value }) => {
    if (!value) {
        return null;
    }
    return (_jsxs(Link, { className: "text-content-subdued flex space-s-1 items-center", onClick: e => e.stopPropagation(), children: [_jsx(LocationMarkerIcon, { className: "w-5 h-5" }, void 0), _jsx("span", { children: value }, void 0)] }, void 0));
};
//# sourceMappingURL=LocationView.js.map